const setItem = (key, item) => {
    try {
        localStorage.setItem(key, JSON.stringify(item));
    } catch (error) {
        console.error('Error setting item in localStorage:', error.message);
    }
};

const getItem = (key) => {
    try {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null; // Parse and return the item or null if not found
    } catch (error) {
        console.error('Error getting item from localStorage:', error.message);
    }
};

const clearItem = (key) => {
    try {
        localStorage.removeItem(key);
    } catch (error) {
        console.error('Error clearing item from localStorage:', error.message);
    }
};

const clearStorage = () => {
    try {
        localStorage.clear();
    } catch (error) {
        console.error('Error clearing localStorage:', error.message);
    }
};

const Storage = {
    setItem,
    getItem,
    clearItem,
    clearStorage,
};

export default Storage;
